import { Divider, Grid2 as Grid, Typography } from '@mui/material';

import { ApiWorkflowDialog, DatasetDetailsModalContent } from '@verantos-dev/shared-components';
import { theme } from '@verantos-dev/shared-styles';

import { useDatasetDetailsModal } from './useDatasetDetailsModal';

export const DatasetDetailsModal = ({
  releaseId,
  releaseName,
  onClose,
}: {
  releaseId: string;
  releaseName: string;
  onClose: () => void;
}) => {
  const {
    subTitle,
    closeDatasetDetailsModal,
    datasetDetailsInfo,
    isLoading,
    isFetching,
    error,
    noDatasetDetailsText,
  } = useDatasetDetailsModal(releaseId, onClose);

  return (
    <ApiWorkflowDialog
      id="datasetDetailsModal"
      title={releaseName}
      onClose={closeDatasetDetailsModal}
      isInitialLoading={isLoading || isFetching}
      initialLoadingError={error}
      displayButtons={false}
    >
      <Divider />
      {datasetDetailsInfo.length > 0 && (
        <Typography marginY={3} variant="subtitle2" sx={{ color: theme.palette.text.primary }}>
          {subTitle}
        </Typography>
      )}
      {datasetDetailsInfo.length === 0 && (
        <Typography
          paddingTop={6}
          textAlign={'center'}
          variant="body2"
          sx={{ color: theme.palette.text.primary }}
        >
          {noDatasetDetailsText}
        </Typography>
      )}
      <Grid container rowSpacing={3} columnSpacing={4} paddingBottom={4}>
        {datasetDetailsInfo.map(({ id, icon, detailName, detailValue }, index: number) => (
          <Grid size={{ xs: 6 }} key={index}>
            <DatasetDetailsModalContent
              id={id}
              icon={icon}
              detailName={detailName}
              detailValue={detailValue}
            />
          </Grid>
        ))}
      </Grid>
    </ApiWorkflowDialog>
  );
};
